// extracted by mini-css-extract-plugin
export default {"linear-chart":"LinearChart_linear-chart__pdjpC","linear-chart__label":"LinearChart_linear-chart__label__53HPH","linear-chart__wrapper":"LinearChart_linear-chart__wrapper__Rbf-e"};